import React from "react";

export function LoadingSpinner(): JSX.Element {
  return (
    <div>
      <img height="32px" src="/img/loading-spinner.svg" />
    </div>
  );
}
